/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Cannot_Move_Into_Self_ToastInputs */



/**
* | output |
* | --- |
* | "Cannot move a folder into itself" |
*
* @param {Explorer_Table_Cannot_Move_Into_Self_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_cannot_move_into_self_toast = /** @type {((inputs?: Explorer_Table_Cannot_Move_Into_Self_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Cannot_Move_Into_Self_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de deplacer un dossier dans lui-meme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Ordner kann nicht in sich selbst verschoben werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile spostare una cartella in se stessa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Невозможно переместить папку саму в себя.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede mover una carpeta hacia sí misma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法将文件夹移动到自身内部。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダをそれ自体の中に移動することはできません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("किसी फ़ोल्डर को उसी फ़ोल्डर में स्थानांतरित नहीं किया जा सकता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não é possível mover uma pasta para dentro dela mesma.")
	return /** @type {LocalizedString} */ ("Cannot move a folder into itself")
});